module.exports = __webpack_public_path__ + "static/img/200244.24c60a87.png";